module.exports = __webpack_public_path__ + "img/poke-tuna.b4afb9fa.png";